jQuery(function($) {

    function getRealValueFromAnalyticsField(str){
        const ns = '(not set)';
        if (!str) return ns;
        const lower = str.toLowerCase();
        if (lower == "undefined" || lower == "null") return ns;
        return str;
    }
    $(document).on('click', '[data-analytics-event]', function(e){
        const el = e.target;
        const d = el.dataset;
        const clickText = el.innerText;
        const obj = {
            "event": getRealValueFromAnalyticsField(d.analyticsEvent),
            "pageType": getRealValueFromAnalyticsField(d.analyticsPageType),
            "clickType": getRealValueFromAnalyticsField(d.analyticsClickType),
            "clickText": getRealValueFromAnalyticsField(clickText.toLowerCase()),
            "buttonName": getRealValueFromAnalyticsField(d.analyticsButtonName),
            "interactionType": getRealValueFromAnalyticsField(d.analyticsInteractionType),
            "linkUrl": getRealValueFromAnalyticsField(d.analyticsLinkUrl),

            "vehicleModel": getRealValueFromAnalyticsField(d.analyticsVehicleModel),
            "vehicleGrade": getRealValueFromAnalyticsField(d.analyticsVehicleGrade),
            "vehicleGradeVariation": getRealValueFromAnalyticsField(d.analyticsVehicleGradeVariation),
            "vehicleType": getRealValueFromAnalyticsField(d.analyticsVehicleType),
            "vehicleFranchise": getRealValueFromAnalyticsField(d.analyticsVehicleFranchise),
            "vehiclePrice": getRealValueFromAnalyticsField(d.analyticsVehiclePrice),
            "vin": getRealValueFromAnalyticsField(d.analyticsVin)
        }
        const dataLayer = window.dataLayer || [];
        dataLayer.push(obj);
    });

    $(window).on('scroll', function(){
        var w = $(window);
        if (w.outerWidth() < 1024){
            var $topbar = $('.uv-topbar');
            var $topbarTitle = $('.uv-topbar-title');
            var topbarTop = $topbar.length ? $topbar.offset().top : null;

            if (w.scrollTop() >= topbarTop){
                $topbarTitle.addClass('sticky');
            }
            else {
                $topbarTitle.removeClass('sticky');
            }
        }
    });

    $(document).on("click", "[data-modal-protected]", function(e) {
        e.stopPropagation();
    });
    $(document).on("click", "[data-modal-dismiss]", function(e) {
        e.preventDefault();
        var $me = $(this);
        var $modal = $me.closest("[role=dialog]");
        var id = $me.attr("id");
        var $btns = $("[data-modal-id=" + id + "]");
        var $vid = $me.find("video");
        var $if = $me.find("iframe[src*=youtube]");
        $modal.attr("aria-hidden", "true");
        $btns.attr("aria-expanded", "false");
        $("body").attr("data-modal-open", "false");
        if (typeof jwplayer !== "undefined" && jwplayer) {
            jwplayer().pause();
        }
        if ($vid.length) {
            $vid[0].pause();
        }
        if ($if.length) {
            var src = $if.attr("src");
            $if.attr("src", "");
            $if.attr("src", src.replace('?autoplay=1', ''));
        }
    });
    $(document).on("click", "[data-modal-id]", function(e) {
        var $me = $(this);
        var modalId = $me.data("modal-id");
        var $modal = $("#" + modalId);
        if ($modal.length) {
            var $if = $modal.find("iframe[src*=youtube]");

            e.preventDefault();
            if ($if.length) {
                var src = $if.attr("src");
                $if.attr("src", src.replace('?autoplay=1', '') + '?autoplay=1')
            }
            $me.attr("aria-expanded", "true")
            $modal.attr("aria-hidden", "false");
            $("body").attr("data-modal-open", "true");
        }
    });
    $(".s-disclaimers [aria-controls]").on('click', function(e) {
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "false";
        var id = $me.attr("aria-controls");
        var el = document.getElementById(id);
        if (el) {
            var $el = $(el);
            $el.attr("aria-hidden", (!isOpen).toString().toLowerCase());
            $me.attr("aria-pressed", isOpen.toString().toLowerCase());
        }
    });

    $(".blog-archive-list [aria-controls]").on('click', function(e) {
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "false";
        var id = $me.attr("aria-controls");
        var el = $(this).parents('li').find('.month-panel-item')[0];
        if (el) 
        {
            var $el = $(el);
            $el.attr("aria-hidden", (!isOpen).toString().toLowerCase());
            $me.attr("aria-pressed", isOpen.toString().toLowerCase());
        }
    });

    $(".tb-tooltip button[aria-controls]").on('click', function(e){
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "true";
        var id = $me.attr("aria-controls");
        var $el = id ? $("#" + id) : null;
        if (!$el.length)  return;
        $el.attr("aria-hidden", isOpen.toString().toLowerCase());
        $me.attr("aria-pressed", (!isOpen).toString().toLowerCase());
        setTooltipPosition($el);
    });
    $(document).on("click", function(e){
        if ($(e.target).closest('.tb-tooltip').length) return;
        $(".tb-tooltip button[aria-pressed=true]").each(function(){
            $(this).trigger('click');
        });
    });

    const sliderSwiperEl = document.querySelector('.vehicle-images-slider #slider');
    const carouselSwiperEl = document.querySelector('.vehicle-images-slider #carousel');
    if (sliderSwiperEl && carouselSwiperEl){  
        const carouselOpts = {
            watchSlidesProgress: true,
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                }
            }
        };
        const carouselSwiper = new Swiper(carouselSwiperEl, carouselOpts);  
        const sliderOpts = {
            thumbs: {
                swiper: carouselSwiper,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            }
        };
        const sliderSwiper = new Swiper(sliderSwiperEl, sliderOpts);
    };

    $('.js-submit').on('click', function(e) {
        $(this).hide();
        $('#spinner').show();
        $('.control-group input,textarea').prop('readonly', true);
        $('.control-group').attr('style', 'opacity:0.5');
    });


    $('.slider li').each(function(){
        // Display loaded slider images (prevents flashing) Run before initiating sliders
        $(this).addClass('loaded--display');
    });

    // todo: check if these are obsoltete?
    $('#siteMain .slider > div > a').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Homepage Banner Link',
            'eventLabel': $(this).attr('href')
        });
    });
    $('#cphBody_rptTiles_lnkTarget_1').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Sell Now Homepage CTA',
        });
    });
    $('a[href="#request-valuation"]').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Request Valuation Button',
        });
    });
    $(document).on('click', '#designstudio-button', function(e) {
        dataLayer.push({
            event: "toyotaLiveChat",
            eventCategory: "Site Actions",
            eventAction: "Live Chat"
        });
    });


    if ($('.main-feature iframe').attr('src') != null) {
        if ($('.main-feature iframe').attr('src').indexOf('youtube.com') > -1) {
            $('.main-feature iframe[src*="youtube.com"]').wrap('<div class="embed-container"></div>');
        }
        if ($('.main-feature iframe').attr('src').indexOf('vimeo.com') > -1) {
            $('.main-feature iframe[src*="vimeo.com"]').wrap('<div class="embed-container"></div>');
        }
    }

    $('.ui-contact-module-respond').on('click', function(){
        $(".ui-contact-module").toggleClass("open");
        $("html").toggleClass("disable-scrolling")
    });

    var ll = new LazyLoad({
        class_loading: "lazy",
        class_loaded: "loaded",
        class_error: "error",
    });

    var specialcars = {
        init: function() {
            this.bindEvents();
            if ($(window).width() > 767){
                $('.detail-filter-container .icon-open').trigger('click');
            }
            setTimeout(function(){
                $('.detail-filter-container .uninit').removeClass('uninit');
            }, 350);
            this.updateResults();
        },
        getParameterByName: function(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },
        amendUrl: function(){
            var $checked = $(".detail-filter-container .filter-radio input:checked");
            var listString = "";
            $checked.each(function () {
                listString += this.attributes["data-model"].value + ",";
            });
            var vcid = this.getParameterByName('vc', location.href);
            vcid = vcid ? window.encodeURIComponent(vcid) : '';
            listString = listString.slice(0, -1);
            var vcidString = vcid ? ('?vc=' + vcid + '&') : '?';
            var newurl = window.location.href.split("?")[0] + vcidString + 'models=' + listString;
            window.history.pushState({ path: newurl }, '', newurl);

            var top = $('.ac-special-vehicle-listings').offset().top;
            $('html, body').animate({
                scrollTop: top - 70
            }, 200);
        },
        setInputsFromUrl: function(){
            var $inputs = $(".detail-filter-container .filter-radio input");
            var qs = location.search.split('models=');
            $inputs.each(function(){
                this.checked = false;
            });
            if (qs.length > 1){
                var qsArray = qs[1].split(',');
                for (var i = 0; i != qsArray.length; ++i){
                    var v = qsArray[i];
                    var $i = $inputs.filter('[data-model=' + v + ']');
                    if ($i.length){
                        $i[0].checked = true;
                    }
                }
            }
        },
        bindEvents: function(){
            var that = this;
            $('.detail-filter-container .so-nav li > a').on('click', function(e){
                var $me = $(this);
                var href = $me.attr('href');
                if (0 == href.indexOf('#') && href.length > 1){
                    e.preventDefault();
                    var $el = $(href);
                    var $nav = $('.detail-filter-container .so-nav');
                    var h = $nav.length ? $nav.outerHeight() : 0;
                    $('html,body').animate({ scrollTop: $el.offset().top - h - 20 }, 500);
                }
            });
            window.addEventListener('popstate', function(e){
                that.setInputsFromUrl();
                that.updateResults();
            });
            $(".detail-filter-container .filter-radio input").on('change', function(){
                that.amendUrl();
                that.updateResults();
            });
            $(".detail-filter-container .js-clear-filters").on('click', function() {
                var $check = $(".detail-filter-container .filter-radio input");
                var url = location.origin + location.pathname;
                $check.each(function(){
                    this.checked = false;
                });
                that.amendUrl();
                that.updateResults();
            });
            $('.detail-filter-container .toggle-filter').on('click', function(e){
                $(this).addClass("open");
            });
            $(".detail-filter-container .icon-open").on('click', function(e) {
                e.preventDefault();
                $(this).closest(".toggle-filter").addClass("open");
            });
            $(".detail-filter-container .icon-close").on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).closest(".toggle-filter").removeClass("open");
            });
            $(".detail-filter-container .mobile-btn").on('click', function(e) {
                e.preventDefault();
                $(".detail-filter-container .icon-open").trigger('click');
            });
            $(".detail-filter-container .vc-collapse").each(function() {
                var $me = $(this);
                $me.find(".panel-btn").on('click', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('active');
                    $me.closest('.vc-collapse').find('.accordion-panel').toggleClass('open');
                });
            });
        }, 
        updateResults: function() {
            var $clear = $('.detail-filter-container .clear');
            var $checked = $(".detail-filter-container .filter-radio input:checked");
            var $listings = $('.detail-filter-container .ac-special-vehicle-listings');
            if ($checked.length == 0){
                $clear.addClass('hidden');
                $('.ac-special-vehicle').removeClass('hidden');
            } 
            else {
                var listString = "";
                $clear.removeClass('hidden');
                $checked.each(function () {
                    listString += "." + this.attributes["data-model"].value + ",";
                });
                listString = listString.slice(0, -1);
                $('.ac-special-vehicle').not(listString).addClass('hidden');
                $('.ac-special-vehicle').filter(listString).removeClass('hidden');
            }
        }
    }
    specialcars.init();

    const elecPopup = localStorage.getItem('elec');
    var showingElecPopup = false;
    if(elecPopup){
        const elecData = JSON.parse(elecPopup);
        if (Date.now() < elecData.expiresAt) {
            var elect = $('#custom-electric-modal');
            if($(elect).length)
            {
                var inst = $(elect).remodal();
                inst.open();
                showingElecPopup = true;
                localStorage.removeItem('elec');
            }
        } else {
            localStorage.removeItem('elec');
        }
    }
    
    if (localStorage.getItem("btn") !=='saved' && !showingElecPopup){
        var customHomeModal = $('#custom-home-modal');
        if($(customHomeModal).length){
            var inst = $(customHomeModal).remodal();
            inst.open();
        }
    }
    $('#btnDoNotShow').on('click', function (e) {
        // add local storge when 'close & remember button' clicked.
        if (e.target){
            localStorage.setItem('btn', 'saved');
        }
    });

    function setTooltipPosition($el) {
        $el.attr('css', "");
        const right = $(window).width() - ($el.offset().left + $el.outerWidth());
        if (right < 16){
            $el.css('left', (right - 16)  + "px");
        }
    }
});

(function(){
    const wrapperMain = document.querySelector('.list-wrapper');
    const scrollProgress = document.querySelector('.progress-bar');

    if (wrapperMain != null && scrollProgress != null){
        const progress = () => {
            const scroll = wrapperMain.scrollLeft;
            const width = wrapperMain.scrollWidth - wrapperMain.clientWidth;
            const percent = (scroll / width) * 100;  
            scrollProgress.style.width = percent + "%";
        }

        wrapperMain.addEventListener('scroll', progress);
    }
    function initSwiperWithScrollbar(options) {
        const { wrapperSelector, scrollbarSelector, swiperOptions } = options;

        const swiperContainer = document.querySelector(wrapperSelector);
        const customScrollbar = document.querySelector(scrollbarSelector);

        if (!swiperContainer || !customScrollbar) {
            return;
        }

        const progressBar = customScrollbar.querySelector('.featured-scrollbar-fill');
        if (!progressBar) {
            console.error('Swiper Initialization Failed: Progress bar fill element not found for', scrollbarSelector);
            return;
        }

        const swiper = new Swiper(swiperContainer, {
            freeMode: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            ...(swiperOptions || {})
        });

        swiperContainer.swiper = swiper;

        if (progressBar) {
            swiper.on('progress', function (s, progress) {
                const actualProgressWidth = progress * 100;
                const newWidth = Math.max(20, actualProgressWidth);
                progressBar.style.width = `${newWidth}%`;
            });
        }

        customScrollbar.addEventListener('click', function(e) {
            const rect = this.getBoundingClientRect();
            const clickPosition = (e.clientX - rect.left) / rect.width;
            swiper.setProgress(clickPosition, 300);
        });

        swiperContainer.dispatchEvent(new CustomEvent('swiper-ready', {
            bubbles: true,
            detail: { swiper: swiper }
        }));

        if (!window.swipers){
            window.swipers = [];
        }

        window.swipers.push({
            selector: swiperContainer,
            scrollbar: customScrollbar,
            instance: swiper
        });

        return swiper;
    }
    document.addEventListener('DOMContentLoaded', function() {
        initSwiperWithScrollbar({
            wrapperSelector: '#cardScrollWrapperThree',
            scrollbarSelector: '.vehicledetail-scroll-progress-bar-alt',
            swiperOptions: {
                centerInsufficientSlides: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 16,
                    },
                    390: {
                        slidesPerView: 1.3,
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: 2.3,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 16,
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 54
                    }
                }
            }
        });
        initSwiperWithScrollbar({
            wrapperSelector: '#cardScrollWrapperTwo',
            scrollbarSelector: '.specialoffers-scroll-progress-bar-alt',
            swiperOptions: {
                spaceBetween: 40,
                centerInsufficientSlides: true,
                simulateTouch: true,
                allowTouchMove: true,
                grabCursor: true,
                freeMode: false,
                sticky: true,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                touchRatio: 1.2,
                breakpoints: {
                    320: {
                        slidesPerView: 1
                    },
                    390: {
                        slidesPerView: 1.3
                    },
                    768: {
                        slidesPerView: 2.3
                    },
                    1024: {
                        slidesPerView: 3.3
                    },
                    1599: {
                        slidesPerView: 4.3
                    },
                }
            }
        });
        initSwiperWithScrollbar({
            wrapperSelector: '#whatsNewScrollWrapper',
            scrollbarSelector: '.whats-new-scroll-progress-bar',
            swiperOptions: {
                simulateTouch: true,
                allowTouchMove: true,
                grabCursor: true,
                centerInsufficientSlides: true,
                freeMode: false,
                sticky: true,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                touchRatio: 1.2,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 12,
                    },
                    390: {
                        slidesPerView: 1.3,
                        spaceBetween: 12,
                    },
                    768: {
                        slidesPerView: 2.3, 
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3, 
                        spaceBetween: 24,
                    }
                }
            }
        });
        initSwiperWithScrollbar({
            wrapperSelector: '#cardScrollWrapperReviews',
            scrollbarSelector: '.reviews-progress-bar',
            swiperOptions: {
                simulateTouch: true,
                allowTouchMove: true,
                grabCursor: true,
                centerInsufficientSlides: true,
                freeMode: false,
                sticky: true,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                touchRatio: 1.2,
                navigation: {
                    nextEl: '.ac-reviews-carousel .swiper-button-next',
                    prevEl: '.ac-reviews-carousel .swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 12,
                    },
                    480: {
                            slidesPerView: 2.2,
                            spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 3, 
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 4, 
                        spaceBetween: 24,
                    }
                }
            },
        });
        initSwiperWithScrollbar({
            wrapperSelector: '#cardScrollWrapper',
            scrollbarSelector: '.featured-scrollbar',
            swiperOptions: {
                spaceBetween: 12,
                centerInsufficientSlides: true,
                simulateTouch: true,
                allowTouchMove: true,
                grabCursor: true,
                centerInsufficientSlides: true,
                freeMode: false,
                sticky: true,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                touchRatio: 1.2,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    390: {
                        slidesPerView: 1.3
                    },
                    768: {
                        slidesPerView: 2.3
                    },
                    1024: {
                        slidesPerView: 3.3
                    },
                    1599: {
                        slidesPerView: 4.3
                    },
                }
            }
        });
        const swiperInstance = initSwiperWithScrollbar({
            wrapperSelector: '#socialsSwiper',
            scrollbarSelector: '.socials-scrollbar',
            swiperOptions: {
                spaceBetween: 24,
                simulateTouch: true,
                allowTouchMove: true,
                grabCursor: true,
                freeMode: false,
                centerInsufficientSlides: true,
                sticky: true,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                touchRatio: 1.2,
                breakpoints: {
                    320: {
                        slidesPerView: 1
                    },
                    375: {
                        slidesPerView: 1.2
                    },
                }
            }
        });

        function manageSocialsSwiper() {
            if (typeof swiperInstance == 'undefined') return;

            const isMobile = window.innerWidth <= 768;

            if (isMobile) {
                swiperInstance.enable();
            } else {
                swiperInstance.disable();
            }
        }
        manageSocialsSwiper();

        let resizeTimer = null;
        function resizeTimeout(){
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(manageScrollbars, 500);
        }
        function manageScrollbars(){
            if (typeof window.swipers == 'undefined') return;
            window.swipers.forEach(function(el){
                console.log('el slidesPerView ', el.selector, ': ', el.instance);
                if (el.instance.slides.length < el.instance.params.slidesPerView){
                    console.log('hide scrollbar', el.scrollbar);
                    el.scrollbar.classList.add('hidden');
                }
                else {
                    console.log('show scrollbar', el.scrollbar);
                    el.scrollbar.classList.remove('hidden');
                }
            });
        }
        window.addEventListener('resize', resizeTimeout);
        manageScrollbars();
    });
    document.addEventListener('DOMContentLoaded', function() {
        function alignCardImages() {
            const cards = document.querySelectorAll('#cardScrollWrapper .swiper-slide .card, #cardScrollWrapper .swiper-slide .sell-card-feature');
            let maxHeaderHeight = 0;

            cards.forEach(card => {
                const header = card.querySelector('.card-header-fixed, .sell-title-featured');
                const imageWrapper = card.querySelector('.image-wrapper, .banner-car-image-feature');
                
                if (header && imageWrapper) {
                    maxHeaderHeight = Math.max(maxHeaderHeight, header.offsetHeight);
                }
            });

            cards.forEach(card => {
                const header = card.querySelector('.card-header-fixed, .sell-title-featured');
                const imageWrapper = card.querySelector('.image-wrapper, .banner-car-image-feature');

                if (header && imageWrapper) {
                    const headerHeight = header.offsetHeight;
                    const marginTop = maxHeaderHeight - headerHeight;
                    imageWrapper.style.marginTop = `${marginTop}px`;
                }
            });
        }
        alignCardImages();
        window.addEventListener('resize', alignCardImages);
    });
document.addEventListener("DOMContentLoaded", function() {
    const reviewWrappers = document.querySelectorAll('.review-content-wrapper');

    reviewWrappers.forEach(wrapper => {
        const textElem = wrapper.querySelector('.review-text');
        const btn = wrapper.querySelector('.read-more-btn');

        const observer = new ResizeObserver(() => {
            if (!textElem.classList.contains('expanded')) {
                if (textElem.scrollHeight > textElem.offsetHeight + 2) {
                    btn.style.display = 'block';
                } else {
                    btn.style.display = 'none';
                }
            }
        });

        observer.observe(textElem);

        btn.addEventListener('click', function() {
            const isExpanding = textElem.classList.toggle('expanded');
            textElem.classList.toggle('line-clamp');
            
            btn.textContent = isExpanding ? 'View less' : 'View more';

            const swiperEl = wrapper.closest('.swiper');
            if(swiperEl && swiperEl.swiper) {
                swiperEl.swiper.update();
            }
        });
    });
});
})();



let searchTimeout;
let searchRequestId = 0;
document.addEventListener('DOMContentLoaded', function() {
$('#vehicleSearch').on('input', function () {

	const query = $(this).val().trim();

	clearTimeout(searchTimeout);

	if (query.length < 2) {
		$('#vehicleSearchResults').hide().empty();
		return;
	}

	searchTimeout = setTimeout(function () {

		const requestId = ++searchRequestId;

		$.ajax({
			url: '/api/Search',
			type: 'GET',
			data: { search: query },
			success: function (response) {

				if (requestId !== searchRequestId) {
					return;
				}

				renderVehicleResults(response);
			}
		});

	}, 300);
});

$('#vehicleSearchBtn').on('click', function () {

	const search = $('#vehicleSearch').val().trim();

	const params = new URLSearchParams();

	if (search) {
		params.set('search', search);
	}

	window.location.href = '/inventory/pre-owned?' + params.toString();
});

function renderVehicleResults(response) {

	const container = $('#vehicleSearchResults');

	container.empty();

	let resultCount = 0;

	response.forEach(function (category) {

		if (!category.vehicles || category.vehicles.length === 0) {
			return;
		}

		 resultCount += category.vehicles.length;

		const categoryElement = $('<div>')
			.addClass('vehicle-search-category');

		$('<div>')
			.addClass('vehicle-search-category-title')
			.text(category.title)
			.appendTo(categoryElement);

		category.vehicles.forEach(function (vehicle) {

			const link = $('<a>')
				.attr('href', vehicle.detailsPageUrl)
				.addClass('vehicle-search-result');

			$('<img>')
				.attr('src', vehicle.imageUrl)
				.attr('alt', vehicle.behicleTitle)
				.appendTo(link);

			const details = $('<div>')
				.addClass('vehicle-search-result-details');

			$('<div>')
				.addClass('vehicle-search-result-title')
				.text(vehicle.vehicleTitle)
				.appendTo(details);

			if (vehicle.price) {
				$('<div>')
					.addClass('vehicle-search-result-price')
					.text(vehicle.price)
					.appendTo(details);
			}

			link.append(details);
			categoryElement.append(link);
		});

		container.append(categoryElement);
	});

	if (resultCount === 0) {
		$('<div>')
			.addClass('vehicle-search-no-results')
			.text('No vehicles found')
			.appendTo(container);
	}

	if (container.children().length > 0) {
		container.show();
	} else {
		container.hide();
	}
}
});


